import { useAuthContext } from 'state/auth';

const useUserHasToVerify = (skip = false) => {
  const { user } = useAuthContext();
  return user?.details.emailVerified === false && !skip;
};

export default useUserHasToVerify;
